<template>
    <div>
        <filter-string :current="filterString"
                       vehicle-type="passenger"
        >
        </filter-string>

        <div class="row">
            <div :class="{
                'col-lg-4': ! showCo2Nedc || ! showCo2Wltp,
                'col-lg-3': showCo2Nedc && showCo2Wltp,
            }">
                <stat-box title="Car Registrations (YTD)"
                          :clickable="true"
                          :target-url="targetUrl"
                          go-to-target=""
                          :exportable="true"
                          :loading="sources.newCarRegistrationsYear.loading"
                >
                    <count-up :end="reports.newCarRegistrationsYear.year"
                              slot="primaryStat"
                              v-if="reports.newCarRegistrationsYear"
                    ></count-up>
                    <span slot="secondaryStat" v-if="reports.newCarRegistrationsYear && reports.newCarRegistrationsYear.change">
                        <percentage-change :figure="reports.newCarRegistrationsYear.change"></percentage-change>
                        on comparison year ({{ reports.newCarRegistrationsYear.lastYear.toLocaleString() }})
                    </span>
                </stat-box>
            </div>
            <div :class="{
                'col-lg-4': ! showCo2Nedc || ! showCo2Wltp,
                'col-lg-3': showCo2Nedc && showCo2Wltp,
            }">
                <stat-box title="Car Registrations (MTD)"
                          :clickable="true"
                          :target-url="targetUrl"
                          go-to-target=""
                          :exportable="true"
                          :loading="sources.newCarRegistrationsMonth.loading"
                >
                    <count-up :end="reports.newCarRegistrationsMonth.year"
                              slot="primaryStat"
                              v-if="reports.newCarRegistrationsMonth"
                    ></count-up>
                    <span slot="secondaryStat" v-if="reports.newCarRegistrationsMonth && reports.newCarRegistrationsMonth.change">
                        <percentage-change :figure="reports.newCarRegistrationsMonth.change"></percentage-change>
                        on comparison year ({{ reports.newCarRegistrationsMonth.lastYear.toLocaleString() }})
                    </span>
                </stat-box>
            </div>
            <div :class="{
                    'col-lg-4': ! showCo2Nedc || ! showCo2Wltp,
                    'col-lg-3': showCo2Nedc && showCo2Wltp,
                 }"
                 v-if="showCo2Wltp"
            >
                <stat-box title="Average CO<sub>2</sub> (WLTP)"
                          :clickable="true"
                          :target-url="targetUrl"
                          go-to-target="sales-by-emissions-wltp"
                          :exportable="true"
                          :loading="sources.averageCo2Wltp.loading"
                >
                    <count-up :end="reports.averageCo2Wltp.year"
                              slot="primaryStat"
                              suffix="g/km"
                              :decimals="2"
                              v-if="reports.averageCo2Wltp"
                    ></count-up>

                    <!-- This is here to make the boxes line up -->
                    <span slot="secondaryStat"
                          v-if="reports.newCarRegistrationsMonth && reports.newCarRegistrationsMonth.change"
                          style="visibility: hidden"
                    >
                        <percentage-change :figure="reports.newCarRegistrationsMonth.change"></percentage-change>
                        on comparison year ({{ reports.newCarRegistrationsMonth.lastYear.toLocaleString() }})
                    </span>
                </stat-box>
            </div>
            <div :class="{
                    'col-lg-4': ! showCo2Nedc || ! showCo2Wltp,
                    'col-lg-3': showCo2Nedc && showCo2Wltp,
                 }"
                 v-if="showCo2Nedc"
            >
                <stat-box title="Average CO<sub>2</sub> (NEDC)"
                          :clickable="true"
                          :target-url="targetUrl"
                          go-to-target="sales-by-emissions"
                          :exportable="true"
                          :loading="sources.averageCo2.loading"
                >
                    <count-up :end="reports.averageCo2.year"
                              slot="primaryStat"
                              suffix="g/km"
                              :decimals="2"
                              v-if="reports.averageCo2"
                    ></count-up>

                    <!-- This is here to make the boxes line up -->
                    <span slot="secondaryStat"
                          v-if="reports.newCarRegistrationsMonth && reports.newCarRegistrationsMonth.change"
                          style="visibility: hidden"
                    >
                        <percentage-change :figure="reports.newCarRegistrationsMonth.change"></percentage-change>
                        on comparison year ({{ reports.newCarRegistrationsMonth.lastYear.toLocaleString() }})
                    </span>
                </stat-box>
            </div>
        </div>
        <div class="row">
            <div class="col-lg-8">
                <div class="Panel Panel--dashboard">
                    <div class="Panel__heading Panel__heading--plain Panel__heading--link" @click.self="goTo()">
                        Total Car Registrations
                        <dashboard-exporter></dashboard-exporter>
                    </div>
                    <div class="Panel__body">
                        <line-chart :labels="reports.totalSalesGraph.labels"
                                    :datasets="reports.totalSalesGraph.datasets"
                                    :display-legend="false"
                                    :height="249"
                                    :title="reports.totalSalesGraph.title"
                                    v-if="reports.totalSalesGraph"
                        ></line-chart>
                    </div>
                    <div class="Panel__overlay" v-show="sources.totalSalesGraph.loading">
                        <div class="Panel__overlay-text">
                            <i class="fa fa-circle-o-notch fa-spin fa-fw"></i> Loading...
                        </div>
                    </div>
                </div>
            </div>
            <div class="col-lg-4">
                <div class="Panel Panel--dashboard">
                    <div class="Panel__heading Panel__heading--plain Panel__heading--link" @click.self="goTo('sales-by-county')">
                        County Registrations
                        <dashboard-exporter></dashboard-exporter>
                    </div>
                    <div class="Panel__body Panel__body--hide-overflow">
                        <high-map :dataset="reports.salesByCountyMap"
                                  title="County Registrations"
                                  :height="249"
                                  v-if="reports.salesByCountyMap"
                        ></high-map>
                        <div class="CountyMap__legend">
                            <ul class="Utility__list-unstyled">
                                <li class="CountyMap__legend-item CountyMap__legend-item--up">
                                    Up
                                </li>
                                <li class="CountyMap__legend-item CountyMap__legend-item--equal">
                                    Equal
                                </li>
                                <li class="CountyMap__legend-item CountyMap__legend-item--down">
                                   Down
                                </li>
                            </ul>
                        </div>
                    </div>
                    <div class="Panel__overlay" v-show="sources.salesByCountyMap.loading">
                        <div class="Panel__overlay-text">
                            <i class="fa fa-circle-o-notch fa-spin fa-fw"></i> Loading...
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div class="row" v-if="showUsedOnlyGraphs">
            <div class="col-md-6">
                <div class="Panel Panel--dashboard">
                    <div class="Panel__heading Panel__heading--plain Panel__heading--link" @click.self="goTo('sales-by-age-profile')">
                        Age Profile
                        <dashboard-exporter></dashboard-exporter>
                    </div>
                    <div class="Panel__body">
                        <bar-chart :labels="reports.salesByAgeProfile.labels"
                                   :datasets="reports.salesByAgeProfile.datasets"
                                   :display-legend="false"
                                   :height="249"
                                   :y-axis-width="60"
                                   :is-used-only="true"
                                   :title="reports.salesByAgeProfile.title"
                                   v-if="reports.salesByAgeProfile"
                        ></bar-chart>
                    </div>
                    <div class="Panel__overlay" v-show="sources.salesByAgeProfile.loading">
                        <div class="Panel__overlay-text">
                            <i class="fa fa-circle-o-notch fa-spin fa-fw"></i> Loading...
                        </div>
                    </div>
                </div>
            </div>

            <div class="col-md-6">
                <div class="Panel Panel--dashboard">
                    <div class="Panel__heading Panel__heading--plain Panel__heading--link" @click.self="goTo('sales-by-origin')">
                        Origin
                        <dashboard-exporter></dashboard-exporter>
                    </div>
                    <div class="Panel__body">
                        <div class="row">
                            <div class="col-md-7" style="height: 249px;">
                                <pie-chart :labels="reports.salesByOrigin.labels"
                                           :datasets="reports.salesByOrigin.datasets"
                                           :height="249"
                                           :display-legend="false"
                                           :is-used-only="true"
                                           :title="reports.salesByOrigin.title"
                                           v-if="reports.salesByOrigin"
                                ></pie-chart>
                            </div>
                            <div class="col-md-5">
                                <graph-legend :labels="reports.salesByOrigin.labels"
                                              :datasets="reports.salesByOrigin.datasets"
                                              display-value="percentage"
                                              v-if="reports.salesByOrigin"
                                ></graph-legend>
                            </div>
                        </div>
                    </div>
                    <div class="Panel__overlay" v-show="sources.salesByOrigin.loading">
                        <div class="Panel__overlay-text">
                            <i class="fa fa-circle-o-notch fa-spin fa-fw"></i> Loading...
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div class="row">
            <div class="col-md-6">
                <div class="Panel Panel--dashboard">
                    <div class="Panel__heading Panel__heading--plain Panel__heading--link" @click.self="goTo('sales-by-make')">
                        Top Makes
                        <dashboard-exporter></dashboard-exporter>
                    </div>
                    <div class="Panel__body">
                        <podium :labels="reports.topSellingMakes.labels"
                                :datasets="reports.topSellingMakes.datasets"
                                :height="249"
                                :title="reports.topSellingMakes.title"
                                v-if="reports.topSellingMakes"
                        ></podium>
                    </div>
                    <div class="Panel__overlay" v-show="sources.topSellingMakes.loading">
                        <div class="Panel__overlay-text">
                            <i class="fa fa-circle-o-notch fa-spin fa-fw"></i> Loading...
                        </div>
                    </div>
                </div>
            </div>
            <div class="col-md-6">
                <div class="Panel Panel--dashboard">
                    <div class="Panel__heading Panel__heading--plain Panel__heading--link" @click.self="goTo('sales-by-model')">
                        Top Models
                        <dashboard-exporter></dashboard-exporter>
                    </div>
                    <div class="Panel__body">
                        <podium :labels="reports.topSellingModels.labels"
                                :datasets="reports.topSellingModels.datasets"
                                :height="249"
                                :title="reports.topSellingModels.title"
                                v-if="reports.topSellingModels"
                        ></podium>
                    </div>
                    <div class="Panel__overlay" v-show="sources.topSellingModels.loading">
                        <div class="Panel__overlay-text">
                            <i class="fa fa-circle-o-notch fa-spin fa-fw"></i> Loading...
                        </div>
                    </div>
                </div>
            </div>
            <div class="col-md-6">
                <div class="Panel Panel--dashboard">
                    <div class="Panel__heading Panel__heading--plain Panel__heading--link" @click.self="goTo('sales-by-engine-type')">
                        Top Engine Types
                        <dashboard-exporter></dashboard-exporter>
                    </div>
                    <div class="Panel__body">
                        <div class="row">
                            <div class="col-md-7" style="height: 249px;">
                                <pie-chart :labels="reports.topSellingEngineTypes.labels"
                                           :datasets="reports.topSellingEngineTypes.datasets"
                                           :display-legend="false"
                                           :height="249"
                                           :title="reports.topSellingEngineTypes.title"
                                           v-if="reports.topSellingEngineTypes"
                                ></pie-chart>
                            </div>
                            <div class="col-md-5">
                                <graph-legend :labels="reports.topSellingEngineTypes.labels"
                                              :datasets="reports.topSellingEngineTypes.datasets"
                                              display-value="percentage"
                                              v-if="reports.topSellingEngineTypes"
                                ></graph-legend>
                            </div>
                        </div>
                    </div>
                    <div class="Panel__overlay" v-show="sources.topSellingEngineTypes.loading">
                        <div class="Panel__overlay-text">
                            <i class="fa fa-circle-o-notch fa-spin fa-fw"></i> Loading...
                        </div>
                    </div>
                </div>
            </div>

            <div class="col-md-6" v-if="canViewSalesTypes">
                <div class="Panel Panel--dashboard">
                    <div class="Panel__heading Panel__heading--plain Panel__heading--link" @click.self="goTo('sales-by-sales-type')">
                        Top Sales Types
                        <dashboard-exporter></dashboard-exporter>
                    </div>
                    <div class="Panel__body">
                        <div class="row">
                            <div class="col-md-7" style="height: 249px;">
                                <pie-chart :labels="reports.topSellingSalesTypes.labels"
                                           :datasets="reports.topSellingSalesTypes.datasets"
                                           :display-legend="false"
                                           :height="249"
                                           :title="reports.topSellingSalesTypes.title"
                                           v-if="reports.topSellingSalesTypes"
                                ></pie-chart>
                            </div>
                            <div class="col-md-5">
                                <graph-legend :labels="reports.topSellingSalesTypes.labels"
                                              :datasets="reports.topSellingSalesTypes.datasets"
                                              display-value="percentage"
                                              :limit="5"
                                              v-if="reports.topSellingSalesTypes"
                                ></graph-legend>
                            </div>
                        </div>
                    </div>
                    <div class="Panel__overlay" v-show="sources.topSellingSalesTypes.loading">
                        <div class="Panel__overlay-text">
                            <i class="fa fa-circle-o-notch fa-spin fa-fw"></i> Loading...
                        </div>
                    </div>
                </div>
            </div>

            <div class="col-md-6">
                <div class="Panel Panel--dashboard">
                    <div class="Panel__heading Panel__heading--plain Panel__heading--link" @click.self="goTo('sales-by-body-type')">
                        Top Body Types
                        <dashboard-exporter></dashboard-exporter>
                    </div>
                    <div class="Panel__body">
                        <bar-chart type="horizontalBar"
                                   :labels="reports.topSellingBodyTypes.labels"
                                   :datasets="reports.topSellingBodyTypes.datasets"
                                   :display-legend="false"
                                   :height="249"
                                   :title="reports.topSellingBodyTypes.title"
                                   v-if="reports.topSellingBodyTypes"
                        ></bar-chart>
                    </div>
                    <div class="Panel__overlay" v-show="sources.topSellingBodyTypes.loading">
                        <div class="Panel__overlay-text">
                            <i class="fa fa-circle-o-notch fa-spin fa-fw"></i> Loading...
                        </div>
                    </div>
                </div>
            </div>
            <div class="col-md-6">
                <div class="Panel Panel--dashboard">
                    <div class="Panel__heading Panel__heading--plain Panel__heading--link" @click.self="goTo('sales-by-colour')">
                        Top Colours
                        <dashboard-exporter></dashboard-exporter>
                    </div>
                    <div class="Panel__body">
                        <bar-chart type="horizontalBar"
                                   :labels="reports.topSellingColours.labels"
                                   :datasets="reports.topSellingColours.datasets"
                                   :display-legend="false"
                                   :height="249"
                                   :title="reports.topSellingColours.title"
                                   v-if="reports.topSellingColours"
                        ></bar-chart>
                    </div>
                    <div class="Panel__overlay" v-show="sources.topSellingColours.loading">
                        <div class="Panel__overlay-text">
                            <i class="fa fa-circle-o-notch fa-spin fa-fw"></i> Loading...
                        </div>
                    </div>
                </div>
            </div>
            <div class="col-md-6">
                <div class="Panel Panel--dashboard">
                    <div class="Panel__heading Panel__heading--plain Panel__heading--link" @click.self="goTo('sales-by-segment')">
                        Top Segments
                        <dashboard-exporter></dashboard-exporter>
                    </div>
                    <div class="Panel__body">
                        <bar-chart type="horizontalBar"
                                   :labels="reports.topSellingSegments.labels"
                                   :datasets="reports.topSellingSegments.datasets"
                                   :display-legend="false"
                                   :height="249"
                                   :title="reports.topSellingSegments.title"
                                   v-if="reports.topSellingSegments"
                        ></bar-chart>
                    </div>
                    <div class="Panel__overlay" v-show="sources.topSellingSegments.loading">
                        <div class="Panel__overlay-text">
                            <i class="fa fa-circle-o-notch fa-spin fa-fw"></i> Loading...
                        </div>
                    </div>
                </div>
            </div>

            <div class="col-md-6">
                <div class="Panel Panel--dashboard">
                    <div class="Panel__heading Panel__heading--plain Panel__heading--link" @click.self="goTo('sales-by-transmission')">
                        Top Transmissions
                        <dashboard-exporter></dashboard-exporter>
                    </div>
                    <div class="Panel__body">
                        <bar-chart type="horizontalBar"
                                   :labels="reports.topSellingTransmissions.labels"
                                   :datasets="reports.topSellingTransmissions.datasets"
                                   :display-legend="false"
                                   :height="257"
                                   :title="reports.topSellingTransmissions.title"
                                   v-if="reports.topSellingTransmissions"
                        ></bar-chart>
                    </div>
                    <div class="Panel__overlay" v-show="sources.topSellingTransmissions.loading">
                        <div class="Panel__overlay-text">
                            <i class="fa fa-circle-o-notch fa-spin fa-fw"></i> Loading...
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <form action="/motorstats/export/dashboard" method="post" ref="form">
            <input name="_token" type="hidden" :value="csrfToken">
            <input name="title" type="hidden" value="Passenger Cars Dashboard">
            <input name="vehicleType" type="hidden" value="passenger">
            <input name="graphs" type="hidden" :value="graphImages">
        </form>
    </div>
</template>

<script>
    import dashboard from '../../../../mixins/dashboard'

    export default {
        data() {
            return {
                reports: {
                    newCarRegistrationsYear: null,
                    newCarRegistrationsMonth: null,
                    averageCo2: null,
                    averageCo2Wltp: null,
                    totalSalesGraph: null,
                    topSellingMakes: null,
                    topSellingModels: null,
                    topSellingEngineTypes: null,
                    topSellingSalesTypes: null,
                    topSellingBodyTypes: null,
                    topSellingColours: null,
                    topSellingSegments: null,
                    salesByCountyMap: null,
                    salesByAgeProfile: null,
                    salesByOrigin: null,
                    topSellingTransmissions: null,
                },

                sources: {
                    newCarRegistrationsYear: { report: 'newCarRegistrationsYear', 'url': '/motorstats/passenger-cars/registrations/ytd' },
                    newCarRegistrationsMonth: { report: 'newCarRegistrationsMonth', 'url': '/motorstats/passenger-cars/registrations/mtd' },
                    averageCo2: { report: 'averageCo2', 'url': '/motorstats/passenger-cars/average-co2' },
                    averageCo2Wltp: { report: 'averageCo2Wltp', 'url': '/motorstats/passenger-cars/average-co2-wltp' },
                    totalSalesGraph: { report: 'totalSalesGraph', 'url': '/motorstats/passenger-cars/total-sales/graph' },
                    salesByCountyMap: { report: 'salesByCountyMap', 'url': '/motorstats/passenger-cars/sales-by-county/map' },
                    salesByAgeProfile: { report: 'salesByAgeProfile', 'url': '/motorstats/passenger-cars/sales-by-age-profile/graph' },
                    salesByOrigin: { report: 'salesByOrigin', 'url': '/motorstats/passenger-cars/sales-by-origin/graph' },
                    topSellingMakes: { report: 'topSellingMakes', 'url': '/motorstats/passenger-cars/sales-by-make/top-five' },
                    topSellingModels: { report: 'topSellingModels', 'url': '/motorstats/passenger-cars/sales-by-model/top-five' },
                    topSellingEngineTypes: { report: 'topSellingEngineTypes', 'url': '/motorstats/passenger-cars/sales-by-engine-type/top-five' },
                    topSellingSalesTypes: { report: 'topSellingSalesTypes', 'url': '/motorstats/passenger-cars/sales-by-sales-type/top-five' },
                    topSellingBodyTypes: { report: 'topSellingBodyTypes', 'url': '/motorstats/passenger-cars/sales-by-body-type/top-five' },
                    topSellingTransmissions: { report: 'topSellingTransmissions', 'url': '/motorstats/passenger-cars/sales-by-transmission/top-five' },
                    topSellingColours: { report: 'topSellingColours', 'url': '/motorstats/passenger-cars/sales-by-colour/top-five' },
                    topSellingSegments: { report: 'topSellingSegments', 'url': '/motorstats/passenger-cars/sales-by-segment/top-five' },
                }
            }
        },

        mixins: [dashboard],

        props: {
            filterString: {
                required: true,
                type: String
            },
        },
    }
</script>